import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6 9C6 7.34315 7.34315 6 9 6H15C16.6569 6 18 7.34315 18 9V15C18 16.6569 16.6569 18 15 18H9C7.34315 18 6 16.6569 6 15V9Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "DummyIconMdFill"
);
